<script>
import Modal from '@wielink-application/shared/vue/components/modal.vue'

export default Modal;
</script>
<template>
	<div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
		<div :class="{'modal-dialog modal-dialog-centered': true, [`modal-${this.size}`]: size}">
			<div class="modal-content">
				<div class="modal-header bg-primary">
					<h2 v-if="title" class="modal-title fs-5" :id="id + 'Label'">{{ title }}</h2>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>

				<div class="modal-body">
					<slot></slot>
				</div>

				<div class="modal-footer" v-if="$slots.footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>